import Vue from 'vue'
import App from './App.vue'
import VueMeta from 'vue-meta';
import Axios from "axios";
import { store } from './store';
// require('vue-flash-message/dist/vue-flash-message.min.css');
import './registerServiceWorker'
import router from './router'
import DynamicRoutes from './services/DynamicRoutes';
import Utils from './mixins/Utils';
Vue.config.productionTip = false
Axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

Vue.use(VueMeta, {
  keyName: 'head'
});

Vue.mixin(Utils);

new Vue({
  router,
  store,
  render: h => h(App),
    created () {
        this.getDynamicRoutes();
    },
  
    methods: {
        /**
         * Get and register applications dynamic routs
         * 
         * @returns {void}
         */
        getDynamicRoutes () {
            DynamicRoutes.getRoutes().then(Axios.spread(function (leftMenuTop) {                
              store.commit('dynamicRoutes', {
                leftMenuTop: leftMenuTop.data.data
              });  
          }));
        },
  }
}).$mount('#app')



$(document).ready(function(){
	$('#mob-nav').click(function(){
		//$('#nav-btn').hide()
		document.getElementById("mobile-nav").style.width = "300px";
		//document.getElementById("wrapper").style.display ="block";
		document.getElementById("body").setAttribute("style","overflow-x:visible;");
		document.getElementById("overlayWrapper").style.display = "block";
	});

	$("#close-btn").click(function(){
		//$('#mobile-nav').show()
		closeNaviMenu();
  });
  
  binCloseMenuEvent();
	
	$(".dropright").hover(function(){
		var dropdownMenu = $(this).children(".dropdown-menu");
		if(dropdownMenu.is(":visible")){
		dropdownMenu.parent().toggleClass("show");
		}
	});

	$("#overlayWrapper").click(function(){
		closeNaviMenu();
  });
  closeNaviMenu();
})

function binCloseMenuEvent(){
  setTimeout(function() {
    $(".mob-link").click(function(){
      closeNaviMenu();
    });
  }, 2500);
}

function closeNaviMenu(){
	document.getElementById("mobile-nav").style.width = "0";
	document.getElementById("body").removeAttribute("style");
  document.getElementById("overlayWrapper").style.display = "none";

  /* collapse all menu elements */
  $('.list-unstyled').collapse('hide');
  $('.menuPlusSign').show();
  $('.menuMinusSign').hide();
}
